module.exports = __webpack_public_path__ + "img/pt.352ff4b.svg";